import { planLengthInMonths } from '../../Utils/priceSimulationUtils';
import type { DisplayPackage, FilterOption } from './PriceSimulation.types';
import { isIncludedGroup } from './priceSimulationModel';
import type { PackageSimulationDto } from './priceSimulationModel';

export const toDisplayPackage = (apiPackage: PackageSimulationDto, selectedTiers: FilterOption[], billingCycle: number): DisplayPackage | null => {
    if (!apiPackage.tiers) return null;

    const filteredTiers = selectedTiers.length > 0 ? apiPackage.tiers.filter((tier) => selectedTiers.some((st) => st.id === tier.tierId)) : apiPackage.tiers;

    if (filteredTiers.length === 0) return null;

    const matchingPlan = (apiPackage.availablePlans ?? []).find((p) => planLengthInMonths(p.identifier ?? p.name) === billingCycle);
    const planIdentifier = matchingPlan?.identifier ?? matchingPlan?.name ?? '';

    return {
        id: apiPackage.packageId ?? '',
        name: apiPackage.packageName ?? null,
        periodMonths: billingCycle,
        hasSelectedPlan: matchingPlan !== undefined,
        tiers: filteredTiers.map((tier) => ({
            id: tier.tierId ?? '',
            name: tier.name,
            periodMonths: billingCycle,
            productGroups: (tier.productGroups ?? []).map((group) => ({
                id: group.groupId ?? '',
                name: group.name,
                productGroupType: isIncludedGroup(group) ? 1 : 0,
                products: (group.products ?? []).map((product) => {
                    const pricePoint = matchingPlan ? product.prices?.[planIdentifier] : undefined;
                    return {
                        id: product.productId ?? '',
                        name: product.name,
                        price: pricePoint ? (pricePoint.currentPrice ?? 0) : null,
                        productType: product.type,
                        isModified: pricePoint?.isModified ?? false,
                    };
                }),
            })),
        })),
    };
};
